interface GoogleErrorLike {
  status?: unknown;
  statusCode?: unknown;
  code?: unknown;
  errorCode?: unknown;
  message?: unknown;
  error?: unknown;
}

const GOOGLE_AUTH_ERROR_CODE = 1401;
const GOOGLE_AUTH_MESSAGE_PATTERN = /invalid credentials|invalid_grant|google (?:access token|authentication|authorization).*?(?:invalid|expired|required)|reconnect (?:your )?google|error refreshing google access token/i;

export function isGoogleAuthorizationError(error: unknown): boolean {
  return inspectError(error, new Set<unknown>(), 0);
}

function inspectError(error: unknown, visited: Set<unknown>, depth: number): boolean {
  if (!error || depth > 4 || visited.has(error)) {
    return false;
  }

  if (typeof error === 'string') {
    return GOOGLE_AUTH_MESSAGE_PATTERN.test(error);
  }

  if (typeof error !== 'object') {
    return false;
  }

  visited.add(error);
  const candidate = error as GoogleErrorLike;
  const status = Number(candidate.status ?? candidate.statusCode);
  const errorCode = Number(candidate.errorCode ?? candidate.code);

  if (status === 401 || errorCode === GOOGLE_AUTH_ERROR_CODE) {
    return true;
  }

  if (typeof candidate.message === 'string' && GOOGLE_AUTH_MESSAGE_PATTERN.test(candidate.message)) {
    return true;
  }

  return inspectError(candidate.error, visited, depth + 1);
}
